import React from 'react';

export default function IconMX() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#73AF00"
                d="M10.666 21.483H.552A.552.552 0 0 1 0 20.93V1.069C0 .764.247.517.552.517h10.114v20.966Z"
            />
            <path fill="#F5F5F5" d="M21.334.517H10.667v20.966h10.667V.517Z" />
            <path
                fill="#FF4B55"
                d="M31.448 21.483H21.333V.517h10.115c.305 0 .552.247.552.552V20.93a.552.552 0 0 1-.552.552Z"
            />
            <path fill="#FFD250" d="M16.951 11.493 16 11.97v.476h.476l.475-.952Z" />
            <path
                fill="#00C3A0"
                d="M15.999 13.634a.238.238 0 0 1-.238-.238v-.951a.238.238 0 1 1 .476 0v.951a.238.238 0 0 1-.238.238Z"
            />
            <path
                fill="#00C3A0"
                d="M15.999 12.683c-.934 0-1.837-.36-2.541-1.015a.238.238 0 0 1 .324-.349 3.254 3.254 0 0 0 2.217.888c.814 0 1.601-.315 2.217-.888a.238.238 0 0 1 .324.349 3.728 3.728 0 0 1-2.541 1.015Z"
            />
            <path
                fill="#00AADC"
                d="M16 13.634c-.61 0-1.2-.178-1.709-.515l.264-.396c.859.57 2.031.57 2.89 0l.263.396a3.077 3.077 0 0 1-1.708.515Z"
            />
            <path fill="#732D37" d="m15.623 10.423-.525.813-.09.267 1.369-.317-.754-.763Z" />
            <path
                fill="#AAD264"
                d="M14.544 11.765c-.629 0-1.384-.53-1.584-1.709l.47-.08c.165.981.769 1.314 1.131 1.313.111-.003.227-.042.236-.12.01-.094.013-.116-.236-.2-.135-.046-.288-.098-.396-.221-.435-.497.154-1.023.438-1.276.05-.044.07-.082.065-.097-.016-.04-.11-.102-.214-.102-.303 0-.532-.17-.599-.445a.636.636 0 0 1 .311-.713l.218.423c-.058.03-.081.116-.066.177.006.025.02.082.136.082.291 0 .568.172.658.409.039.1.097.363-.193.621-.312.28-.499.49-.395.608.023.026.124.06.19.083.214.072.613.207.556.705-.036.314-.316.531-.696.541h-.03Z"
            />
            <path
                fill="#874150"
                d="M16.476 9.114s.476-.951-.476-1.427c0 0 3.33-.476 2.855 3.806-.313-.25-.776-.706-.942-1.07l-1.437-.833v-.476Z"
            />
            <path fill="#732D37" d="m16 10.066 2.379 1.427-.952.476L16 10.542v-.476Z" />
            <path
                fill="#783C46"
                d="M15.048 8.639c.263 0 .476.213.476.475a.933.933 0 0 0-.175 1.077l.107.215c.045.09.104.172.175.243l1.32 1.32v-.657c0-.82-.19-1.627-.557-2.36a1.428 1.428 0 0 0-1.276-.79h-.07v.477Z"
            />
            <path
                fill="#FFD250"
                d="m15.048 8.163-.475.476v.475s.566-.287.756-.378c.134-.064.11-.215.033-.288-.06-.056-.314-.285-.314-.285Z"
            />
            <path
                fill="#AAD264"
                d="M16 14.586a4.049 4.049 0 0 1-4.044-4.044h.476c0 1.968 1.6 3.568 3.568 3.568s3.569-1.6 3.569-3.568h.475A4.049 4.049 0 0 1 16 14.586Z"
            />
            <path
                fill="#FFE15A"
                d="M12.458 12.277a.323.323 0 1 0 0-.646.323.323 0 0 0 0 .646ZM13.172 13.416a.323.323 0 1 0 0-.645.323.323 0 0 0 0 .645ZM14.331 14.278a.323.323 0 1 0 0-.645.323.323 0 0 0 0 .645ZM19.578 12.277a.323.323 0 1 0 0-.646.323.323 0 0 0 0 .646ZM18.863 13.416a.323.323 0 1 0 0-.645.323.323 0 0 0 0 .645ZM17.704 14.278a.323.323 0 1 0 0-.645.323.323 0 0 0 0 .645Z"
            />
            <path
                fill="#FFB478"
                d="M16.238 13.872h-.476a.476.476 0 0 1 0-.951h.476a.476.476 0 0 1 0 .951Z"
            />
            <path
                fill="#9B4B5A"
                d="M17.913 10.423c.159.466.496.892.941 1.07C19.33 7.211 16 7.687 16 7.687c2.379 0 1.913 2.736 1.913 2.736Z"
            />
        </svg>
    );
}
